function SearchDropdown() {
}

SearchDropdown.fn = {
    init: function () {
        SearchDropdown.fn.bind.call(this);
    },

    bind: function () {
        var searchTimer = null;

        $(document).on("keyup", ".search-autocomplete", function () {
            var $input = $(this);

            if (searchTimer) {
                clearTimeout(searchTimer);
            }

            searchTimer = setTimeout(function () {
                SearchDropdown.fn.search.call(this, $input);
            }, 400);
        });

        $(document).on("focus", ".search-autocomplete", function () {
            var $input = $(this);
            var $result = $input.closest("form").find(".search-result");

            if ($result.find(".suggest_search").length) {
                $result.show();
            }
        });

        $(document).on("click", function (event) {
            var $target = $(event.target);

            if (!$target.closest(".search-autocomplete").length && !$target.closest(".search-result").length) {
                $(".search-result").hide();
            }
        });
    },

    search: function ($input) {
        var keyword = $input.val();
        var $result = $input.closest("form").find(".search-result");

        if (!keyword || keyword.trim().length === 0) {
            $result.hide().empty();
            return;
        }

        $.ajax({
            url: $input.data("action"),
            type: "post",
            dataType: "json",
            data: {
                s: keyword,
                _token: $('meta[name="csrf-token"]').attr("content")
            },
            success: function (response) {
                if (response.success && response.data) {
                    $result.show().html(response.data);
                } else {
                    $result.hide().empty();
                }
            }
        });
    },

    rule: function () {
        $(document).ready(function () {
            SearchDropdown.fn.init.call(this);
        });
    },
};

SearchDropdown.fn.rule();
